import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
} from 'react-bootstrap';
import countries from 'country-calling-code';
import moment from 'moment';
import { DateInput } from '@opuscapita/react-dates';

import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class Publish extends Component {
  handlePublished(e, value) {
    // const { fields } = this.props;
    // const publishInfo = fields.publishInfo || {};

    const published = e.target.checked ? value : !value;
    this.props.assignAttribute('published', published);

    // Reset firstDate
    // if (!publishInfo || !publishInfo.firstDate) {
    //   this.handleDate(new Date());
    // }
  }

  handleText(e, key) {
    const { fields } = this.props;

    e.preventDefault();
    if (key === 'completionYear') {
      if (e.target.value.length > 4 || e.target.value.length < 0) {
        return;
      }

      if (/^\d*$/.test(e.target.value) === false) {
        return;
      }
    }

    let publishInfo = fields.publishInfo || {};
    publishInfo[key] = e.target.value || '';

    this.props.assignAttribute('publishInfo', { ...publishInfo });
  }

  handleDate = (date) => {
    const { fields } = this.props;
    let publishInfo = fields.publishInfo || {};

    const firstDate = moment(date).format('MM/DD/YYYY');
    publishInfo['firstDate'] = firstDate;

    this.props.assignAttribute('publishInfo', { ...publishInfo });
  };

  handleNext() {
    const { fields } = this.props;
    const publishInfo = fields.publishInfo || {};

    this.props.hideAlert();
    let checked = true;

    if (fields.published === undefined) {
      checked = false;
    } else if (!publishInfo.completionYear) {
      checked = false;
    } else if (fields.published === true) {
      if (!publishInfo.firstDate) {
        checked = false;
      } else if (!publishInfo.firstNation) {
        checked = false;
      }
    }

    if (checked) {
      this.props.assignAttribute('publishInfoStatus', fields.published);
      this.props.router.push('/copyright-reg/select-work');
    } else {
      this.props.alert('error', 'Please check the required fields.');
    }
  }

  handleBack() {
    this.props.router.goBack();
  }

  checkValidDate(dateVal) {
    if (Object.prototype.toString.call(dateVal) === '[object Date]') {
      if (isNaN(dateVal)) {
      } else {
        return dateVal;
      }
    } else {
    }

    return null;
  }

  render() {
    const { fields } = this.props;
    const publishInfo = fields.publishInfo || {};
    let firstDate = null;

    if (publishInfo && publishInfo.firstDate) {
      firstDate = new Date(publishInfo.firstDate);
      // firstDate = publishInfo.firstDate;
    }

    return (
      <div className="publish">
        <Heading text="Release Information" />
        <div className="content">
          <p>
            <span className="text-red">*</span>
            <b>Has this work been released?</b>
          </p>
          <p>
            If your titles were not all released on the same date, please go
            back and file each separately.
          </p>
          <Form>
            <FormGroup>
              <Checkbox
                checked={fields.published === false}
                onChange={(e) => this.handlePublished(e, false)}
              >
                No
              </Checkbox>
              <Checkbox
                checked={fields.published === true}
                onChange={(e) => this.handlePublished(e, true)}
              >
                Yes
              </Checkbox>
            </FormGroup>

            {fields.published === true ? (
              <div className="inner">
                <FormGroup>
                  <ControlLabel className="w-200px">
                    <span className="text-red">*</span>Year of completion:{' '}
                  </ControlLabel>
                  <FormControl
                    type="text"
                    className="inline"
                    placeholder="yyyy"
                    value={publishInfo.completionYear || ''}
                    onChange={(e) => this.handleText(e, 'completionYear')}
                  />
                </FormGroup>
                <FormGroup className="d-flex align-items-center">
                  <ControlLabel className="w-200px">
                    <span className="text-red">*</span>Date of first
                    publication:
                  </ControlLabel>
                  <DateInput
                    className="inline"
                    value={this.checkValidDate(firstDate)}
                    dateFormat="MM-DD-YYYY"
                    disabled={false}
                    locale="en"
                    onChange={this.handleDate}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel className="w-200px">
                    <span className="text-red">*</span>Nation of first
                    publication:{' '}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    className="inline"
                    value={
                      publishInfo.firstNation && publishInfo.firstNation !== ''
                        ? publishInfo.firstNation
                        : -1
                    }
                    onChange={(e) => this.handleText(e, 'firstNation')}
                  >
                    <option disabled key={-1} value={-1}>
                      Select Country
                    </option>
                    {countries.map((country, i) => (
                      <option key={i} value={country.country}>
                        {country.country}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
                <p>
                  If you have any of these ID numbers, you may enter them below.
                  Use a comma ( , ) to separate multiple ID numbers.
                </p>
                <div className="inner">
                  <FormGroup>
                    <ControlLabel>ISBN: </ControlLabel>
                    <FormControl
                      type="text"
                      className="inline"
                      value={publishInfo.isbn || ''}
                      onChange={(e) => this.handleText(e, 'isbn')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>ISRC: </ControlLabel>
                    <FormControl
                      type="text"
                      className="inline"
                      value={publishInfo.isrc || ''}
                      onChange={(e) => this.handleText(e, 'isrc')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>ISWC: </ControlLabel>
                    <FormControl
                      type="text"
                      className="inline"
                      value={publishInfo.iswc || ''}
                      onChange={(e) => this.handleText(e, 'iswc')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>ISMN: </ControlLabel>
                    <FormControl
                      type="text"
                      className="inline"
                      value={publishInfo.ismn || ''}
                      onChange={(e) => this.handleText(e, 'ismn')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>ISAN: </ControlLabel>
                    <FormControl
                      type="text"
                      className="inline"
                      value={publishInfo.isan || ''}
                      onChange={(e) => this.handleText(e, 'isan')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>ISTC: </ControlLabel>
                    <FormControl
                      type="text"
                      className="inline"
                      value={publishInfo.istc || ''}
                      onChange={(e) => this.handleText(e, 'istc')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>EIDR: </ControlLabel>
                    <FormControl
                      type="text"
                      className="inline"
                      value={publishInfo.eidr || ''}
                      onChange={(e) => this.handleText(e, 'eidr')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>ISSN: </ControlLabel>
                    <FormControl
                      type="text"
                      className="inline"
                      value={publishInfo.issn || ''}
                      onChange={(e) => this.handleText(e, 'issn')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Pre-registration #: </ControlLabel>
                    <FormControl
                      type="text"
                      className="inline"
                      value={publishInfo.preRegNum || ''}
                      onChange={(e) => this.handleText(e, 'preRegNum')}
                    />
                  </FormGroup>
                </div>
              </div>
            ) : (
              <div className="inner">
                <FormGroup>
                  <ControlLabel className="w-200px">
                    <span className="text-red">*</span>Year of completion:{' '}
                  </ControlLabel>
                  <FormControl
                    type="text"
                    className="inline"
                    placeholder="yyyy"
                    value={publishInfo.completionYear || ''}
                    onChange={(e) => this.handleText(e, 'completionYear')}
                  />
                </FormGroup>
                <p>
                  Note, you can only register up to <b>10</b> unreleased works
                  using one application.
                </p>
              </div>
            )}
          </Form>
        </div>
        <br />
        <br />
        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handleBack()} />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Publish);



// WEBPACK FOOTER //
// src/components/Copyright/Publish.jsx